var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8.33398V7.00065H6.66667V8.33398H5.33333ZM2.66667 8.33398V7.00065H4V8.33398H2.66667ZM8 8.33398V7.00065H9.33333V8.33398H8ZM5.33333 11.0007V9.66732H6.66667V11.0007H5.33333ZM2.66667 11.0007V9.66732H4V11.0007H2.66667ZM8 11.0007V9.66732H9.33333V11.0007H8ZM0 13.6673V1.66732H2V0.333984H3.33333V1.66732H8.66667V0.333984H10V1.66732H12V13.6673H0ZM1.33333 12.334H10.6667V5.66732H1.33333V12.334Z",
    fill: "#8A548B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.52ab5581db29dd6b8a568da9391f71b5.svg";
export { ForwardRef as ReactComponent };